module.exports = __webpack_public_path__ + "static/img/IMG_20240424_194819.9a73a0ef.jpg";